<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "DriverIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
